<template>
  <v-form ref="form">
    <v-text-field
      v-model="umUser.name"
      label="Name"
      required
      :rules="[v => !!v || 'Name is required']"
    ></v-text-field>

    <v-autocomplete
      :items="countries"
      item-text="title"
      item-value="code"
      v-model="umUser.countryCode"
      label="Country"
      required
      :rules="[v => !!v || 'Country is required']"
    ></v-autocomplete>

    <v-text-field
      :prefix="umUser.countryCode"
      v-model="umUser.mobileNumber"
      label="Mobile Number"
      required
      :rules="mobileNumberRules"
    ></v-text-field>

    <v-text-field v-model="umUser.email" label="E-mail" required :rules="emailRules"></v-text-field>

    <v-text-field
      v-if="type != 'UPDATE'"
      v-model="umUser.password"
      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
      :type="showPassword ? 'text' : 'password'"
      label="Password"
      :rules="passwordRules"
      required
      @click:append="showPassword = !showPassword"
    ></v-text-field>

    <v-autocomplete
      :items="organization"
      item-text="name"
      item-value="_id"
      v-model="dbUser.organizationId"
      label="Organization"
    ></v-autocomplete>

    <v-select
      v-model="dbUser.roles"
      :items="roles"
      label="User Roles"
      multiple
      required
      :rules="[v => v.length > 0 || 'User Role is required']"
    ></v-select>

    <v-autocomplete
      v-model="dbUser.vendorCodes"
      multiple
      :items="vendorCode"
      item-text="name"
      item-value="code"
      label="Vendor Code(s)"
      required
      :rules="[v => v.length > 0 || 'Vendor Code(s) is required']"
    ></v-autocomplete>

    <v-select
      v-model="dbUser.status"
      :items="status"
      label="Status"
      required
      :rules="[v => !!v || 'Status is required']"
    ></v-select>

    <v-btn class="mr-5" color="primary" @click="$router.push({ name: 'VendorUsers' })">Back</v-btn>
    <v-btn class="mr-5" color="primary" @click="updateUser()" v-if="type == 'UPDATE'">Update</v-btn>
    <v-btn class="mr-5" color="primary" @click="createUser()" v-if="type == 'CREATE'">Create</v-btn>
  </v-form>
</template>

<script>
import RestResource from "../../services/dataServiceVendor";
import CommonRestResouce from "../../services/dataServiceAdmin";
import MobileRestResource from "../../services/dataServiceMobile";
const service = new RestResource();
const commonService = new CommonRestResouce();
const mobileService = new MobileRestResource();
export default {
  name: "CreateUser",
  props: {
    umUser: Object,
    dbUser: Object,
    type: String
  },
  data() {
    return {
      organization: [],
      countries: [],
      vendorCode: [],
      showPassword: false,
      roles: ["VENDOR", "ADMIN"],
      status: [
        {
          text: "Active",
          value: "A"
        },
        {
          text: "Inactive",
          value: "I"
        }
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      mobileNumberRules: [value => !!value || "Mobile number required."],
      passwordRules: [
        value => !!value || "Password required.",
        value => (value || "").length >= 8 || `Min 8 characters`
      ]
    };
  },
  mounted() {
    this.loadOrganization();
    this.fetchCountries();
    this.loadProjectCodes();
  },

  methods: {
    loadOrganization() {
      commonService.fetchOrganizations().then(r => {
        this.organization = r.data.organizations;
      });
    },
    fetchCountries() {
      commonService.getConfig("countries").then(r => {
        this.countries = r.data;
      });
    },
    createUser() {
      if (this.$refs.form.validate()) {
        this.$setLoader();
        service.createUser({ ...this.umUser, ...this.dbUser }).then(r => {
          if (r != undefined) {
            alert("Successfully created user");
            this.$router.push({ name: "VendorUsers" });
          }
          this.$disableLoader();
        });
      }
    },

    async updateUser() {
      if (this.$refs.form.validate()) {
        this.updateDBAndUMUser(this.dbUser, this.umUser);
      }
    },

    updateDBAndUMUser(dbUser, umUser) {
      this.dbUser.type = "Vendor";
      dbUser.updated_at = Date.now();
      dbUser.updated_by = this.$store.state.userProfile.name

      this.$setLoader();
      service.updateUser(this.dbUser).then(() => {
        umUser.updated_at = Date.now();
        commonService.updateUMUser(umUser).then(() => {
          this.$disableLoader();
          alert("Successfully updated user");
        }).catch(() => {
          this.$disableLoader();
          alert("Failed to update user");
        });
      }).catch(() => {
        this.$disableLoader();
        alert("Failed to update user");
      });
    },
    loadProjectCodes() {
      this.$setLoader();
      mobileService.fetchProjectCodes().then(r => {
        this.vendorCode = r.data;
        this.$disableLoader();
      });
    }
  }
};
</script>

